import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import { useSelector } from "react-redux";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import {
  setSelectedEntityType,
  setTerritoryLanguageFilter,
} from "../../../../../features/metaEntitiesSlice";
import { useSearchParams } from "react-router-dom";

interface TerritoryProps {
  open: boolean;
  handleClose: () => void;
  languageName: any;
  setLanguageName: any;
  territoryName: any;
  setTerritoryName: any;
  selectedShareuid: any;
  setSelectedSharedUid: any;
  setMetaTerritories: any;
}

function EditTerritoryModal({
  open,
  handleClose,
  languageName,
  setLanguageName,
  territoryName,
  setTerritoryName,
  selectedShareuid,
}: TerritoryProps) {
  const token = useSelector(setUserToken);
  const outhTokenHeader = token?.payload?.user?.userToken;
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const updateTerritories = async () => {
    const data = {
      territory_name: territoryName,
      language: languageName,
    };
    try {
      setLoading(true);
      setIsLoading(true);
      if (outhTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.updateMetaTerritory(
          outhTokenHeader,
          data,
          selectedShareuid
        );
        dispatch(setSelectedEntityType(""));
        dispatch(setTerritoryLanguageFilter(null));
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete("filters"); // Remove filters
        setSearchParams(newSearchParams);
      } else {
        throw new Error("User doesn't have permissions to create Devie Type");
      }
      if (outhTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaTerritory(
          outhTokenHeader,
          dispatch
        );
      }
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
      setIsLoading(false);
      handleClose();
      await MetaEntitiesEndPointLogic.getMetaTerritory(
        outhTokenHeader,
        dispatch
      );
    }
  };

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
        >
          <Paper sx={{ padding: "16px 24px 20px 24px" }}>
            <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
              Edit New Territory
            </DialogTitle>
            <Typography sx={{ mb: 1 }}>Details</Typography>
            <Grid container mt={0} columnSpacing={3}>
              <Grid item xs={6}>
                <TextField
                  value={territoryName}
                  onChange={(e: any) => setTerritoryName(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Territory Name *" // Set your label here
                  placeholder="Enter unique territory Name" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={languageName}
                  onChange={(e: any) => setLanguageName(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Language *" // Set your label here
                  placeholder="Define language for this territory" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Typography
              sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
            >
              All fields are mandatory.
            </Typography>

            <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
              <Button color="secondary" onClick={handleClose} sx={{ mr: 1 }}>
                CANCEL
              </Button>
              <Button
                variant="contained"
                color="secondary"
                disabled={!setTerritoryName}
                onClick={updateTerritories}
                data-tracker="235"
              >
                Save changes <SaveOutlinedIcon sx={{ ml: 1 }} />
              </Button>
            </Stack>
          </Paper>
        </Dialog>
      )}
    </>
  );
}

export default EditTerritoryModal;
